module.exports = __webpack_public_path__ + "static/img/index_image04.e43a9a09.png";